import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    CommonRoutes,
} from 'app/enums/common.enums'

import {
    DailyOpsFields,
} from '../dailyOps.types'

import deliveryViaRoadFields from './deliveryViaRoad.fields'

const config: SkyNetTableConfig<DailyOpsFields> = {
    name: 'DeliveryViaRoadConfirm',
    tabs: [{
        name: 'Delivery: Confirmation',
        url: CommonRoutes.All,
        fields: deliveryViaRoadFields,
    }],
}

export default config
